// extracted by mini-css-extract-plugin
export default {"BirthDateInput":"bft_a bic_z bic_kc bic_qx bic_xc bic_eg","BirthDateInput--disabled":"bft_b bic_fo"};